import { type ComponentType } from 'react';
import { AllDoneSlide } from './components/slides/AllDoneSlide';
import { BackupCodesSlide } from './components/slides/BackupCodesSlide';
import { BankAccountSlide } from './components/slides/BankAccountSlide';
import { ConnectPhoneSlide } from './components/slides/ConnectPhoneSlide';
import { FreeOptionSlide } from './components/slides/FreeOptionSlide';
import { OpenSecureSlide } from './components/slides/OpenSecureSlide';
import { ReviewSubmitSlide } from './components/slides/ReviewSubmitSlide';
import { SecureAccountSlide } from './components/slides/SecureAccountSlide';
import { SignInSlide } from './components/slides/SignInSlide';
import { TitleSlide } from './components/slides/TitleSlide';
import { WhatYouNeedSlide } from './components/slides/WhatYouNeedSlide';
export type DeckSlide = {
  // Stable id — keep it matching this slide's screen id in canvas.manifest.js.
  id: string;
  // On-slide title — should match the Screen name in canvas.manifest.js.
  title: string;
  component: ComponentType;
};
export const slides: DeckSlide[] = [{
  id: 'scr_lz3h3y',
  title: "Finishing Leslie Outreach's Stripe Setup",
  component: TitleSlide
}, {
  id: 'scr_needs1',
  title: "What you'll need",
  component: WhatYouNeedSlide
}, {
  id: 'scr_step01',
  title: 'Sign in to Stripe',
  component: SignInSlide
}, {
  id: 'scr_step02',
  title: 'Open "Secure your account"',
  component: OpenSecureSlide
}, {
  id: 'scr_step03',
  title: 'Secure your account',
  component: SecureAccountSlide
}, {
  id: 'scr_step3b',
  title: 'Connect your phone',
  component: ConnectPhoneSlide
}, {
  id: 'scr_step3c',
  title: 'Save your backup codes',
  component: BackupCodesSlide
}, {
  id: 'scr_step04',
  title: 'Add extras: choose the free option',
  component: FreeOptionSlide
}, {
  id: 'scr_step05',
  title: 'Review and submit',
  component: ReviewSubmitSlide
}, {
  id: 'scr_step06',
  title: 'Add the bank account for donations',
  component: BankAccountSlide
}, {
  id: 'scr_done01',
  title: "You're all done!",
  component: AllDoneSlide
}];